import { ArrowRight01Icon } from 'hugeicons-react';
import { getRelativeTime } from '../../../helpers/chatHelper';
import { Space } from '../../../types/space';
import '../../../Styles/Space/Spaces Page/SpaceCard.css';
import { useNavigate } from 'react-router-dom';

interface SpaceCardProps {
  space: Space;
  onClick?: () => void;
}

const SpaceCard: React.FC<SpaceCardProps> = ({ space, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(`/spaces/${space.id}`);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      className="space-card"
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <div className="space-card-header">
        <h3>{space.title}</h3>
      </div>
      <div className="space-card-footer">
        {space.lastAssessed && (
          <p className="last-activity-time">
            {getRelativeTime(space.lastAssessed.toString())}
          </p>
        )}
        <ArrowRight01Icon size={16} className="arrow-icon" />
      </div>
    </div>
  );
};

export default SpaceCard;
